import { getFutureDate } from '../../../utils/dateFunctions';
import { NOT_FUTURE_DATE_ERROR } from '../../../utils/formValidation/commonErrorConstants';
import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import {
    getReqMessage,
    getSelectMessage
} from '../../../utils/formValidation/errorMessageFunctions';
import { validateEmail } from '../../../utils/formValidation/validationFunctions';

export const validate = (newEntry, initialState, rightToWorkDocumentType, type) => {
    let newErrors = {};

    if (!newEntry.rightToWorkDocumentTypeId) {
        newErrors = {
            ...newErrors,
            rightToWorkDocumentTypeId: {
                error: true,
                message: getSelectMessage('right to work document type')
            }
        };
    }

    if (rightToWorkDocumentType?.expiry_date_required) {
        if (!newEntry.rightToWorkDocumentExpiryDate) {
            newErrors = {
                ...newErrors,
                rightToWorkDocumentExpiryDate: {
                    error: true,
                    message: getReqMessage('Right to work document expiry date')
                }
            };
        } else if (!getFutureDate(newEntry.rightToWorkDocumentExpiryDate)) {
            newErrors = {
                ...newErrors,
                rightToWorkDocumentExpiryDate: {
                    error: true,
                    message: NOT_FUTURE_DATE_ERROR
                }
            };
        }
    }

    newErrors = validateEmail(
        newEntry.jobCentrePlusContactEmail,
        newErrors,
        'jobCentrePlusContactEmail'
    );

    if (type === 'edit' && Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialState);

    return newErrors;
};
